export default __webpack_public_path__ + "static/media/the-kitchen-aarhus.0f802948.jpg";